<form
  [formGroup]="form"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
>
  <!-- Card -->

  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="supervisorNaming"
        >
          <span class="fs-3">{{
            'supervisorSkillsModule.supervisorNaming' | translate
          }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i
        ></button>
      </h2>
      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="supervisorNaming">
      <fieldset class="mb-4">
        <legend class="form-label" id="supervisorNameLabel"
          >{{ 'supervisorSkillsModule.supervisorName' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  id="flag-nl-s1"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="supervisorNameLabel flag-nl-s1"
                formControlName="supervisorDisplayNameNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  id="flag-en-s1"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="supervisorNameLabel flag-en-s1"
                formControlName="supervisorDisplayNameEn"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  id="flag-fr-s1"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="supervisorNameLabel flag-fr-s1"
                formControlName="supervisorDisplayNameFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  id="flag-de-s1"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="supervisorNameLabel flag-de-s1"
                formControlName="supervisorDisplayNameDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="mb-4">
        <legend class="form-label">{{ 'general.show' | translate }} </legend>
        <div class="ps-3">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="showOnlyFirstName"
              formControlName="showOnlyFirstName"
              (change)="
                onInputChange('showOnlyFirstName', $event.currentTarget.checked)
              "
              [checked]="form.controls.showOnlyFirstName.value"
            />
            <label for="showOnlyFirstName">{{
              'general.firstName' | translate
            }}</label>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="showFirstAndLastName"
              formControlName="showFirstAndLastName"
              (change)="
                onInputChange(
                  'showFirstAndLastName',
                  $event.currentTarget.checked
                )
              "
              [checked]="form.controls.showFirstAndLastName.value"
            />
            <label for="showFirstAndLastName">{{
              'general.firstAndLastName' | translate
            }}</label>
          </div>
        </div>
      </fieldset>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
